<template>
  <div>
    <vue-table :table-data="tableData" @finish="tableFinish" ref="tableRef">
      <template slot="expire" slot-scope="{row}">
        <span>{{formatExpire(row, 'expire')}}</span>
      </template>
      <template slot="searchBar">
        <el-form-item label="授权时间">
          <date-range-picker :start.sync="tableData.search.start_at" :end.sync="tableData.search.end_at" type="before" width="250px"></date-range-picker>
        </el-form-item>
        <el-form-item label="SN">
          <el-input v-model.trim="tableData.search.sn" clearable></el-input>
        </el-form-item>
      </template>
    </vue-table>
  </div>
</template>

<script>
import DateRangePicker from "@view/components/date/DateRangePicker"
import {Base64} from "js-base64";
import {commonChanger,oemType} from "@utils/formatList";
export default {
  name: "index",
  components: {DateRangePicker},
  data() {
    return {
      // 表格数据
      tableData: {
        tableList: [],
        tableColumn: [
          {label: "授权时间", property: "create_at"},
          {label: "设备型号", property: "model"},
          {label: "SN", property: "sn", width: 200},
          {label: "应用识别", property: "shibie_en", width: 80, format: commonChanger},
          {label: "平台", property: "plat"},
          {label: "授权主机数", property: "hi_num"},
          {label: "最大WAN口数", property: "wan_num"},
          {label: "到期时间", property: "expire"},
          {label: "LAN口MAC", property: "lan_mac"},
          {label: "WAN口MAC", property: "wan_mac"},
          {label: "OEM", property: "oem",format: oemType},
        ],
        hasExpand: true,
        expandColumn: [
          {label: "ID", property: "id"},
          {label: "SN", property: "sn"},
          {label: "设备型号", property: "model"},
          {label: "自定义型号", property: "model_x"},
          {label: "应用识别", property: "shibie_en", format: commonChanger},
          {label: "自定义应用识别", property: "shibie_en_x", format: commonChanger},
          {label: "授权主机数", property: "hi_num"},
          {label: "自定义主机数", property: "hi_num_x"},
          {label: "最大WAN口数", property: "wan_num"},
          {label: "自定义WAN口数", property: "wan_num_x"},
          {label: "到期时间", property: "expire", formatFun: this.formatExpire},
          {label: "自定义到期时间", property: "expire_x", formatFun: this.formatExpire},
          {label: "授权时间", property: "create_at"},
          {label: "平台", property: "plat"},
          {label: "OEM", property: "oem",format: oemType},
          {label: "LAN口MAC", property: "lan_mac"},
          {label: "WAN口MAC", property: "wan_mac"},
          {label: "IP地址", property: "ip"},
          {label: "浏览器", property: "browser"},
        ],
        api: "getAuthLog",
        search: {
          sn: "",
          start_at: "",
          end_at: "",
        },
      },
    }
  },
  methods: {
    formatExpire(row, prop) {
      return this.getCurrentTime("full", row[prop] * 1000)
    },
    tableFinish() {
      this.tableData.tableList.forEach(row => {
        const contentObj = JSON.parse(row.content);
        const originObj = JSON.parse(Base64.decode(contentObj.origin));
        let customObj = JSON.parse(Base64.decode(contentObj.custom));
        customObj = this.getSuffixObj(customObj, "x");
        Object.assign(row, contentObj, originObj, customObj)
      })
    },
    getSuffixObj(obj = {}, suffix = "") {
      const res = {}
      Object.keys(obj).forEach(key => res[`${key}_${suffix}`] = obj[key])
      return res;
    },
    getTableList() {
      this.$refs["tableRef"].refresh();
    },
  },
}
</script>

<style scoped>

</style>